import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import type { RoutingCardData } from './types';

/** Carte d'aiguillage : toute la carte est un lien vers la page de l'activité. */
const RoutingCard: React.FC<RoutingCardData> = ({ icon: Icon, title, description, price, to, featured = false }) => (
  <Link
    to={to}
    className={`group card-hover relative flex h-full items-start gap-4 p-4 sm:p-5 md:flex-col lg:flex-row lg:items-center ${
      featured ? '!border-accent/60 !bg-accent/[0.07] hover:!border-accent' : ''
    }`}
  >
    {featured && (
      <span className="label-mono absolute -top-2.5 right-4 rounded-full bg-accent-strong px-2.5 py-1 text-white">
        Le plus demandé
      </span>
    )}
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-line bg-surface-2 text-accent-soft">
      <Icon size={20} aria-hidden />
    </span>
    <span className="flex min-w-0 flex-1 flex-col gap-1.5">
      <span className="text-base font-bold leading-tight text-fg sm:text-[17px]">{title}</span>
      <span className="text-sm leading-snug text-fg-muted">{description}</span>
      <span className="price mt-1 text-[15px] text-accent-soft">{price}</span>
    </span>
    <ArrowRight
      size={18}
      aria-hidden
      className="hidden shrink-0 self-center text-fg-subtle transition-[color,transform] duration-200 group-hover:translate-x-0.5 group-hover:text-accent-soft sm:block md:hidden lg:block"
    />
  </Link>
);

export default RoutingCard;
